import { render, staticRenderFns } from "./SetGeneral.vue?vue&type=template&id=15578c41&scoped=true&"
import script from "./SetGeneral.vue?vue&type=script&lang=js&"
export * from "./SetGeneral.vue?vue&type=script&lang=js&"
import style0 from "./SetGeneral.vue?vue&type=style&index=0&id=15578c41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15578c41",
  null
  
)

export default component.exports